module.exports = __webpack_public_path__ + "img/winner-page-extra.5cbe6076.png";